import React from 'react';

import type { FormatOptionLabelMeta, OptionType } from '@atlaskit/select';
import Select from '@atlaskit/select';

import {
  StatusCategory,
  StatusCategorySelectOption,
} from '@qality/common-model';
import { StringUtils } from '@qality/common-utils';

import {
  StatusTypeOptionContainerStyled,
  StatusTypeOptionTextStyled,
} from './StatusCategorySelect.styled';

export const StatusTypes: Record<StatusCategory, string> = {
  FAILED:
    'Steps or executions will be considered as executed, and contain defects.',
  PASSED: 'Steps or executions will be considered as executed without issues.',
  UNFINISHED: 'Steps or executions will be considered as unexecuted.',
  FINISHED: 'Steps or executions will be considered as executed.',
};

type Props = {
  onChange: (value: StatusCategory) => void;
  defaultValue?: StatusCategory;
  isLoading?: boolean;
};

export default function StatusCategorySelect({
  onChange,
  defaultValue = 'UNFINISHED',
  isLoading = false,
}: Props): JSX.Element {
  const mapStatusColorsToOptions = (
    optionsArg: Array<StatusCategory>
  ): Array<StatusCategorySelectOption> => {
    return optionsArg.map(mapStatusTypeToOption);
  };

  const mapStatusTypeToOption = (
    option: StatusCategory
  ): StatusCategorySelectOption => {
    return {
      label: option,
      value: option,
    };
  };

  const formatOptionLabel = (
    option: OptionType,
    { context }: FormatOptionLabelMeta<OptionType>
  ) => {
    if (context === 'menu') {
      return (
        <StatusTypeOptionContainerStyled>
          {StringUtils.capitalize(option.label)}
          <StatusTypeOptionTextStyled>
            {StatusTypes[option.label]}
          </StatusTypeOptionTextStyled>
        </StatusTypeOptionContainerStyled>
      );
    }
    return StringUtils.capitalize(option.label);
  };

  return (
    <Select
      testId='status-type-select'
      isLoading={isLoading}
      onChange={(target) => {
        onChange(target.value as StatusCategory);
      }}
      options={mapStatusColorsToOptions(
        Object.keys(StatusTypes) as StatusCategory[]
      )}
      defaultValue={mapStatusTypeToOption(defaultValue)}
      formatOptionLabel={formatOptionLabel}
      styles={{
        menu: (provided) => ({
          ...provided,
          width: '400px',
        }),
        container: (provided) => ({
          ...provided,
          width: '204px',
        }),
      }}
    />
  );
}
